// axios
import axios from 'axios'
import store from '@/store/store'

export const baseURL = 'https://api30teb.behnoo.net/' // must have '/' at the end

const instance = axios.create({
  baseURL,
  // You can add your headers here
  headers: {
    common: {
      Authorization: `Bearer ${localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken')}`
    }
  }
})

export const setInterceptors = () => {
  instance.interceptors.response.use(
    res => res,
    err => {
      const code = err.response?.status

      if (code === 401 && (localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo')))
        store.dispatch('auth/logout')
      return Promise.reject(err)
    }
  )
}

export default instance
